import { Switch } from "@mui/material";
import DownloadIcon from "../assets/downloadIcon.svg";

const HospitalList = ({
  hospitals,
  handlePreApproveAdmission,
  setSelectedHospitalId,
  setApproveModal,
  setRejectModal
}) => {
  if (!hospitals.length) {
    return <div className="text-center text-gray-500 py-8">No hospitals found</div>;
  }

  return (
    <div className="mt-7">
      <div className="grid grid-cols-5 font-semibold text-[#191919] px-2">
        <div>Status</div>
        <div>Hospital Name</div>
        <div>Pre-Approved</div>
        <div>Location</div>
        <div>Serial Number</div>
      </div>

      {hospitals.map((hospital, idx) => (
        <div key={hospital.id} className={`${idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"} rounded-[12px]`}>
          <div className="grid grid-cols-5 px-2">
            {/* Status */}
            <div>
              <div className={`w-fit text-xs font-semibold rounded-full px-4 py-1 uppercase mt-4 ${
                hospital.status.toLowerCase() === "inactive" ? "text-[#BCA03C] bg-[#FFF3C6]"
                  : hospital.status.toLowerCase() === "active" ? "text-[#017C57] bg-[#CDFAF4]"
                  : hospital.status.toLowerCase() === "rejected" ? "text-[#CF3636] bg-[#FFD6DB]" : ""
              }`}>
                {hospital.status}
              </div>
            </div>
            {/* Name */}
            <div>
              <div className="text-sm text-[#797979] mt-4">{hospital.name}</div>
            </div>
            {/* Pre-Approved Switch */}
            <div>
              <Switch
                checked={hospital?.preAdmissionApproval === "ACTIVE"}
                onChange={() => window.confirm("Do you want to change status?")
                  && handlePreApproveAdmission(hospital)}
                style={{ color: "#017C57" }}
              />
            </div>
            {/* Location */}
            <div className="text-sm text-[#797979] mt-4">
              {hospital?.city}, {hospital?.state}, {hospital?.country}, {hospital?.pincode}
            </div>
            {/* Serial Number */}
            <div className="text-sm text-[#797979] mt-4">{hospital.id}</div>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-4 text-xs p-4">
            <button
              style={{ border: `1px solid ${hospital.businessDocumentUrl ? "#017C57" : "#EEEEEE"}` }}
              className={`rounded-full px-4 py-2 ${hospital.businessDocumentUrl ? "text-[#017C57]" : "text-gray-300"}`}
              onClick={() => { setSelectedHospitalId(hospital.id); setRejectModal(true); }}
            >
              Reject
            </button>
            <button
              style={{ border: `1px solid ${hospital.businessDocumentUrl ? "#017C57" : "#EEEEEE"}` }}
              className={`text-white rounded-full px-4 py-2 ${hospital.businessDocumentUrl ? "bg-[#017C57]" : "bg-gray-300"}`}
              onClick={() => { setSelectedHospitalId(hospital.id); setApproveModal(true); }}
            >
              Approve
            </button>
            <a
              href={hospital.businessDocumentUrl} download
              style={{ border: `1px solid ${hospital.businessDocumentUrl ? "#017C57" : "#EEEEEE"}` }}
              className={`flex items-center gap-2 text-white rounded-full px-4 py-2 ${hospital.businessDocumentUrl ? "bg-[#017C57]" : "bg-gray-300"}`}
            >
              <img src={DownloadIcon} alt="download-icon" /> Download License
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HospitalList;
